import { get } from 'lodash';
import { useQuery } from 'react-query';

import { createHttpClient } from '@api/http-client';
import { END_POINTS } from '@constants/api-endpoints';
import { QUERY_KEYS } from '@constants/query-keys';
import { AlertType } from '@enums/alert';
import { showAlert } from '@lib/alert/alert-manager';
import { addClientTokenToLocalStorage } from '@utils/auth';

import { SelectWorkspaceResponse } from '../types';

export const useSelectWorkspace = ({
  clientUuid,
  enabled,
  onSuccess,
  onError,
}: {
  clientUuid: string;
  enabled: boolean;
  onSuccess: () => void;
  onError?: () => void;
}) => {
  const client = createHttpClient();

  const query = useQuery(
    [QUERY_KEYS.WORKSPACE.SELECT_WORKSPACE, clientUuid],
    () =>
      client<SelectWorkspaceResponse>({
        url: END_POINTS.WORKSPACE.SELECT_CLIENT(clientUuid),
      }),
    {
      enabled,
      onSuccess: data => {
        if (clientUuid) {
          // On select client success, set client token to local storage
          addClientTokenToLocalStorage({
            clientUuid,
            clientToken: get(data, 'accessToken')!,
          });
        }

        onSuccess();
      },
      onError: (error: Error) => {
        showAlert({
          type: AlertType.ERROR,
          header: 'Failed to select workspace',
          message: `${error?.message || 'Request failed'}`,
        });

        if (onError) {
          onError();
        }
      },
    },
  );

  return query;
};
